export const enhancer = (el) => {
  const form = el.getElementsByTagName('form')[0];
  form.classList.add('wpcf7--redirect-form');
  document.addEventListener('wpcf7mailsent', (e) => {
    window.location.assign(el.getAttribute('data-form-url'));
  }, false);
};
